var $578ee7c11dcdde7a$exports = {};
$578ee7c11dcdde7a$exports = {
  "calendar": "Koledar",
  "day": "dan",
  "dayPeriod": "dop/pop",
  "endDate": "Datum konca",
  "era": "doba",
  "hour": "ura",
  "minute": "minuta",
  "month": "mesec",
  "second": "sekunda",
  "selectedDateDescription": function selectedDateDescription(args) {
    return "Izbrani datum: ".concat(args.date);
  },
  "selectedRangeDescription": function selectedRangeDescription(args) {
    return "Izbrano obmo\u010Dje: ".concat(args.startDate, " do ").concat(args.endDate);
  },
  "selectedTimeDescription": function selectedTimeDescription(args) {
    return "Izbrani \u010Das: ".concat(args.time);
  },
  "startDate": "Datum za\u010Detka",
  "timeZoneName": "\u010Dasovni pas",
  "weekday": "dan v tednu",
  "year": "leto"
};
export { $578ee7c11dcdde7a$exports as default };